import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, SeoGuard } from './@core/guard';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { ForemanPowerbiReportComponent } from './foreman-powerbi-report/foreman-powerbi-report.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: './pages/pages.module#PagesModule',
    canActivate: [SeoGuard],
    data: {
      title: ['All modules'],
      desc: 'Voltas'
    }
  },
  {
    path: 'pages',
    loadChildren: './pages/pages.module#PagesModule',
    canActivate: [AuthGuard, SeoGuard],
    data: {
      title: ['All modules'],
      desc: 'Voltas'
    }
  },
  {
    path: 'login',
    loadChildren: './login/login.module#LoginModule',
    canActivate: [SeoGuard],
    data: {
      title: ['Login'],
      desc: 'Voltas'
    }
  },
  {
    path: 'terms-codition',
    component: TermsConditionComponent,
    canActivate: [SeoGuard],
    data: {
      title: ['Privacy Policy'],
      desc: 'Voltas'
    }
  },
  {
    path: 'powerbi-foreman/:id',
    component: ForemanPowerbiReportComponent,
    data: {
      title: ['PowerBi Report'],
      desc: 'Voltas'
    }
  },
  { path: 'error', loadChildren: './shared/pages/server-error/server-error.module#ServerErrorModule' },
  { path: 'access-denied', loadChildren: './shared/pages/access-denied/access-denied.module#AccessDeniedModule' },
  { path: 'not-found', loadChildren: './shared/pages/not-found/not-found.module#NotFoundModule' },
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
